export enum ModalNames {
  "selectReceiverAddress" = "selectReceiverAddress",
  "selectReceiverPickupPoint" = "selectReceiverPickupPoint",
  "selectSenderAddress" = "selectSenderAddress",
  "labels" = "labels",
  "confirmRefetchShipmentRates" = "confirmRefetchShipmentRates",
  "confirmCloseCreateShipmentModal" = "confirmCloseCreateShipmentModal",
  "confirmRerunRulesModal" = "confirmRerunRulesModal",
  "confirmDeleteShipmentProfile" = "confirmDeleteShipmentProfile",
  "confirmCancelShipment" = "confirmCancelShipment",
  "confirmUncancelShipment" = "confirmUncancelShipment",
  "confirmCancelPickup" = "confirmCancelPickup",
  "confirmBulkDeleteShipmentsModal" = "confirmBulkDeleteShipmentsModal",
  "confirmBulkDeleteAddressesModal" = "confirmBulkDeleteAddressesModal",
  "createQuotePalletSwitchWarningModal" = "createQuotePalletSwitchWarningModal",
  "createQuoteGirthWarningModal" = "createQuoteGirthWarningModal",
  "createBulkShipment" = "createBulkShipment",
  "createSingleLabel" = "createSingleLabel",
  "editBulkShipmentProfile" = "editBulkShipmentProfile",
  "createRule" = "createRule",
  "createReceiverAddress" = "createReceiverAddress",
  "createCompanyAddress" = "createCompanyAddress",
  "createBulkShipmentProfile" = "createBulkShipmentProfile",
  "createShipment" = "createShipment",
  "editRule" = "editRule",
  "customerOnStopWarning" = "customerOnStopWarning",
  "viewQuote" = "viewQuote",
  "viewShipment" = "viewShipment",
  "viewCase" = "viewCase",
  "exceptionNotifications" = "exceptionNotifications",
  "shipmentReport" = "shipmentReport",
  "labelReport" = "labelReport",
  "quoteReport" = "quoteReport",
  "helpContactInfo" = "helpContactInfo",
  "pickUpModal" = "pickUpModal",
  "pickUpRequestModal" = "pickUpRequestModal",
  "viewPickupModal" = "viewPickupModal",
  "selectImporterAddress"= "selectImporterAddress",
  "bulkEditShipmentsModal" = "bulkEditShipmentsModal",
  "bulkAddServicesModal" = "bulkAddServicesModal",
  "uploadAddresses" = "uploadAddresses",
  "surchargeReport" = "surchargeReport",
  "scanAndPrint" = "scanAndPrint",
  "podImage" = "podImage",
  "createDemoAccount" = "createDemoAccount",
}
